import { useState ,useEffect } from "react";
import { useNavigate } from "react-router-dom"

import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";

import RoomScene from "../RoomScene/RoomScene"

import styles from './RoomSceneList.module.css'

// Generate a list of roomscenes
export default function RoomSceneList({seriesId, thumbnailSize, onSceneSelect, filterDescription}) {

    const[sceneData, setSceneData] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // Get active pattern and selected products for selection parameter
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlotProducts = useSelector(state => state.visualizer.selectedSlotProducts);

    // Pull the roomscene series for the passed series id
    useEffect(()=>{
        const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${seriesId}.json`;
        fetch(URL)
        .then((response) => response.json())
        .then((data) => setSceneData(data));
    },[seriesId])
    
    // Generate selection parameter
    const generateSelectionParam = () => {
        if (!activePattern) {
            return null;
        }

        const patternId = activePattern.id || activePattern.patternId || '';
        
        // Get selected product IDs
        const productIds = [];
        if (activePattern.descriptor) {
            const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
            colorSlots.forEach((slot, index) => {
                const product = selectedSlotProducts[index];
                if (product && product.id) {
                    productIds.push(product.id);
                } else {
                    productIds.push('-1');
                }
            });
        }

        if (productIds.length > 0) {
            return `${patternId}(${productIds.join(',')})`;
        }
        
        return patternId;
    };

    // Handles roomscene select event
    const handleRoomsceneSelect = function(specifier) {
        // If custom onSceneSelect callback is provided, use it (for RoomViewPage)
        if (onSceneSelect) {
            onSceneSelect(specifier);
            return;
        }
        
        // Default behavior (for modals) - navigate with selection parameter
        dispatch(uiActions.setViewInRoomModalActive(false)); // Close ViewInRoomModal
        
        const selectionParam = generateSelectionParam();
        if (selectionParam) {
            navigate(`/roomview/${encodeURIComponent(specifier)}/selection/${encodeURIComponent(selectionParam)}`);
        } else {
            navigate(`/roomview/${encodeURIComponent(specifier)}`);
        }
    }

    // Generates an array of RoomScene template items
    // Filter scenes based on filterDescription prop
    const filteredScenes = filterDescription 
        ? sceneData.filter(scene => scene.description === filterDescription)
        : sceneData;

    // Sort scenes by description (category) alphabetically
    const sortedScenes = [...filteredScenes].sort((a, b) => {
        const descA = (a.description || '').toLowerCase();
        const descB = (b.description || '').toLowerCase();
        
        // Handle empty descriptions - put them at the end
        if (!descA && !descB) return 0;
        if (!descA) return 1;
        if (!descB) return -1;
        
        return descA.localeCompare(descB);
    });

    let rsItems = sortedScenes.map(scene => <RoomScene 
        key={scene.productId} 
        specifier={scene.specifier} 
        thumbnailSize={thumbnailSize} 
        onSelect={handleRoomsceneSelect}
        isActive={false}
        />)

        // Only show upload specs when no filter is applied (All option)
        let uploadSpecs = "";
        if (!filterDescription) {
            var uploadImages = localStorage.getItem("UPLOAD_SPECS");

            if(uploadImages !== null){
                uploadSpecs = <RoomScene 
                key={0} 
                specifier={uploadImages} 
                thumbnailSize={thumbnailSize} 
                onSelect={handleRoomsceneSelect}
                isActive={false}
                />
            }
        }

    return(
        <div className={styles.roomsceneListContainer}>
            <ol className={styles.roomsceneList}>
                {uploadSpecs}
                {rsItems}
            </ol>
        </div>
    )
}

// #TODO
// Manage roomscenen active status, Usage of context API?

